
/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */
import React from 'react';
import logoImage from '/app-images/logo_constantina_transparent.png';

interface LogoProps {
  className?: string;
}

const Logo: React.FC<LogoProps> = ({ className = "h-8 w-auto" }) => {
  const [imageError, setImageError] = React.useState(false);

  if (imageError) {
    return (
      <span className={`font-serif font-bold text-xl tracking-tight ${className?.includes('text-white') ? 'text-white' : 'text-gray-900 dark:text-white'}`}>
        Constantina
      </span>
    );
  }

  return (
    <img
      src={logoImage} // Start with imported logo
      srcSet="/favicon.png 1x" // Fallback to favicon if logo missing
      alt="Constantina Styling Advisor Logo"
      className={className}
      onError={(e) => {
        // Fallback logic manually
        const target = e.target as HTMLImageElement;
        if (target.src.includes('favicon.png')) {
          setImageError(true);
        } else {
          target.src = '/favicon.png';
        }
      }}
    />
  );
};

export default Logo;
